/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Events_Not_In_Team_Project_TitleInputs */

const en_team_sync_events_not_in_team_project_title = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events Not In Team Project`)
};

const fr_team_sync_events_not_in_team_project_title = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événements non inclus dans le projet d’équipe`)
};

const de_team_sync_events_not_in_team_project_title = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisse, die nicht im Teamprojekt enthalten sind`)
};

const it_team_sync_events_not_in_team_project_title = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi non presenti nel progetto di squadra`)
};

const ru_team_sync_events_not_in_team_project_title = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`События, не входящие в командный проект`)
};

const es_team_sync_events_not_in_team_project_title = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos que no están en el proyecto de equipo`)
};

const zh_cn2_team_sync_events_not_in_team_project_title = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`团队项目中未包含的事件`)
};

const ja_team_sync_events_not_in_team_project_title = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームプロジェクトに含まれないイベント`)
};

const hi_team_sync_events_not_in_team_project_title = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम प्रोजेक्ट में शामिल नहीं होने वाली घटनाएँ`)
};

const pt_pt2_team_sync_events_not_in_team_project_title = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos que não fazem parte do projeto em equipe`)
};

/**
* | output |
* | --- |
* | "Events Not In Team Project" |
*
* @param {Team_Sync_Events_Not_In_Team_Project_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_events_not_in_team_project_title = /** @type {((inputs?: Team_Sync_Events_Not_In_Team_Project_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Events_Not_In_Team_Project_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_sync_events_not_in_team_project_title(inputs)
	if (locale === "de") return de_team_sync_events_not_in_team_project_title(inputs)
	if (locale === "it") return it_team_sync_events_not_in_team_project_title(inputs)
	if (locale === "ru") return ru_team_sync_events_not_in_team_project_title(inputs)
	if (locale === "es") return es_team_sync_events_not_in_team_project_title(inputs)
	if (locale === "zh-CN") return zh_cn2_team_sync_events_not_in_team_project_title(inputs)
	if (locale === "ja") return ja_team_sync_events_not_in_team_project_title(inputs)
	if (locale === "hi") return hi_team_sync_events_not_in_team_project_title(inputs)
	if (locale === "pt-PT") return pt_pt2_team_sync_events_not_in_team_project_title(inputs)
	return en_team_sync_events_not_in_team_project_title(inputs)
});